import React from 'react';
import { Card, CardContent, CardMedia, Typography, Rating, Button, IconButton, Box } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { useDispatch, useSelector } from 'react-redux';
import { addToWishlist, removeFromWishlist } from '../redux/wishlistSlice';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  const dispatch = useDispatch();
  const wishlist = useSelector(state => state.wishlist.wishlist);

  const addToWishlistHandler = () => {
    dispatch(addToWishlist(product)); 
  };

  const removeFromWishlistHandler = () => {
    dispatch(removeFromWishlist(product.id));
  };

  const isInWishlist = () => {
    return wishlist.some(item => item.id === product.id);
  };

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', position: 'relative' }}>
      <CardMedia
        component="img"
        alt={product.title}
        height="auto"
        image={product.imgSrc}
        sx={{ objectFit: 'contain', maxHeight: 200, mt: 2 }}
      />
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', px: 2, pt: 2 }}>
        <Typography variant="subtitle1" gutterBottom noWrap sx={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', mb: 1 }}>
          {product.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {product.author}
        </Typography>
        <Rating name="read-only" value={product.rating} readOnly />
        <Typography variant="h6" color="text.primary" sx={{ mt: 'auto' }}>
          ₹{product.price}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ textDecoration: 'line-through' }}>
          ₹{product.oldPrice}
        </Typography>
      </CardContent>
      <Box sx={{ position: 'absolute', top: 5, right: 5, border: '2px solid #ccc', borderRadius: '50%' }}>
        <IconButton
          onClick={isInWishlist() ? removeFromWishlistHandler : addToWishlistHandler}
          color={isInWishlist() ? 'secondary' : 'default'}
          sx={{ borderRadius: '50%', backgroundColor: '#fff' }}
        >
          <FavoriteIcon />
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <Link to={`/products/${product.id}`} style={{ textDecoration: 'none' }}>
          <Button variant="contained" color="primary">
            View Details
          </Button>
        </Link>
      </Box>
    </Card>
  );
};

export default ProductCard;
